import { ImGithub, ImLinkedin } from "react-icons/im";
import { SiLeetcode } from "react-icons/si";
import { BsJournals } from "react-icons/bs";

export const LinksData = [
  {
    title: "GitHub",
    icon: <ImGithub color='#d4f0ffdc' />,
    link: "https://github.com/ampersandor",
  },
  {
    title: "LinkedIn",
    icon: <ImLinkedin color='#d4f0ffdc' />,
    link: "https://www.linkedin.com/in/ampersandor/",
  },
  // {
  //   title: "Blog",
  //   icon: <BsJournals color='#d4f0ffdc' />,
  //   link: "https://ampersandor.tistory.com/",
  // },
  {
    title: "Algorithm",
    icon: <SiLeetcode color='yellow' />,
    link: "https://ampersandor.notion.site/7b7b3151f61448588e7258f64cea0ce5?v=26334b58a0cb4e30a365352be1ed64db&pvs=73",
  },
];
